import { render, staticRenderFns } from "./FormBuilderUserData.vue?vue&type=template&id=5b329e8a&scoped=true"
import script from "./FormBuilderUserData.vue?vue&type=script&lang=js"
export * from "./FormBuilderUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b329e8a",
  null
  
)

export default component.exports